import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sound-body" }
const _hoisted_2 = { class: "sound-list-container" }
const _hoisted_3 = { class: "progress-container" }
const _hoisted_4 = { class: "voice-container" }
const _hoisted_5 = { class: "slider-content" }
const _hoisted_6 = { class: "slider-value" }

import { ref, reactive, onMounted, watch, onUnmounted, getCurrentInstance } from 'vue'
import { getUserSoundsSetting, saveUserSoundsSetting } from '@/service'
import {useStore} from 'vuex'
import { $enum } from '@/global'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const { proxy } = getCurrentInstance()!
let messageDuration = 1200
const loading = ref(false)
const saveLoading = ref(false)
const state = reactive({
    droneSound:{
        label:'飞机音效',
        value:0,
        step:1,
        min:0,
        max:100,
    },
    humanSound:{
        label:'语言音效',
        value:0,
        step:1,
        min:0,
        max:100,
    },
    otherSound:{
        label:'其他音效',
        value:0,
        step:1,
        min:0,
        max:100,
    }
})

async function getData(id:string | number){
    for(let item of Object.values(state)){
        item.value = 0
    }
    if(id == -1){
        window?.playClick()
        loading.value = true
    }
    let {code,data} = await getUserSoundsSetting({id:id}) as any
    if(loading.value){
        loading.value = false
    }
    if(code != $enum.EnumResult.SUCCESS){
        if(id == -1){
            proxy?.vknMessage.error({
                message:"恢复默认失败！",
                duration: messageDuration,
            })
        }
        return;
    }
    if(id == -1){
       proxy?.vknMessage.success({
            message:"恢复默认成功！",
            duration: messageDuration,
        })
    }
    if(data && Object.keys(data).length > 0){
        for(let [key,item] of Object.entries(state)){
            item.value = data[key]
        }
    }
}

async function saveSensitivity(){
    window?.playClick()
    let params = {
        userId: store.state.persistence.userInfo.userId,
        droneSound: state.droneSound.value,
        humanSound: state.humanSound.value,
        otherSound: state.otherSound.value,
    }
    saveLoading.value = true
    let {code,data} = await saveUserSoundsSetting(params) as any
    saveLoading.value = false
    if(code != $enum.EnumResult.SUCCESS){
        proxy?.vknMessage.error({
            message:"保存失败！",
            duration: messageDuration,
        })
        return;
    }
    store.commit('persistence/setSounds', params)
    proxy?.vknMessage.success({
        message:"保存成功！",
        duration: messageDuration,
    })
}

onMounted(() => {
    getData(store.state.persistence.userInfo.userId)
})
onUnmounted(() => {
    // proxy?.vknMessage.close();
})

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_vkm_settingChildPage = _resolveComponent("vkm-settingChildPage")!

  return (_openBlock(), _createBlock(_component_vkm_settingChildPage, {
    class: "sound-container",
    "restore-loading": loading.value,
    "save-loading": saveLoading.value,
    onRestore: _cache[0] || (_cache[0] = ($event: any) => (getData(-1))),
    onSave: saveSensitivity
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "sound-item setting-child-body",
              key: index
            }, [
              _createElementVNode("p", null, _toDisplayString(item.label), 1),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["iconfont-line", {
                            'vk_sygb_line': item.value == 0,
                            'vk_syr_line': item.value > 0 && item.value <= 70,
                            'vk_syq_line': item.value > 70
                        }])
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_slider, {
                    class: "custom-controller-slider",
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => ((item.value) = $event),
                    step: item.step,
                    min: item.min,
                    max: item.max,
                    "show-tooltip": false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "min", "max"])
                ]),
                _createElementVNode("span", _hoisted_6, _toDisplayString((item.value).toFixed(0)) + "%", 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["restore-loading", "save-loading"]))
}
}

})